import { CARD_VARIANT_IDS_ENABLED } from '@moonpig/web-core-brand/config'

export const getCardVariantIdsEnabled = () => {
  return CARD_VARIANT_IDS_ENABLED
}
